import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import {
  Button,
  Checkbox,
  LinearProgressBar,
  Select,
  Table,
  Textfield,
  Modal,
  Snackbar,
  LoadingComponent,
} from "../../../components/core";
import { Strings } from "../../../constants/strings";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { NumericFormat } from "react-number-format";
import {
  CREATE_OPERATOR_ACCOUNT_MUTATION,
  OPERATORS,
  OPERATOR_ACCOUNTS_BY_FILTER,
  UPDATE_OPERATOR_ACCOUNTS_MUTATION,
} from "../../../constants/graphql/auth-queries";
import { removeEmptyFields } from "../../../algorithms/remove-fields";
import { Dialog } from "primereact/dialog";
import { ALL_OPERATOR_ACCOUNT_ROLES } from "../../../constants/graphql/operator_account_roles";
import TotalRecords from "../../../components/core/total-records";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { paginatorTemplate } from "../settings-coins/components/paginatorTemplate";
import { Badge } from "primereact/badge";
import { Button as PrimereactButton } from "primereact/button";
import { InputText } from "primereact/inputtext";
import {
  DELETE_OPERATOR_ACCOUNT,
  GET_OPERATOR_ROLES,
} from "../../../constants/graphql/account-roles";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
export default function OperatorAccounts() {
  // email regex used sa global admin
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;

  // local states
  const [operatorList, setOperatorList] = React.useState([]);
  const [operatorAcciuntList, setOperatorAccountList] = React.useState([]);
  const [filter, setFilter] = React.useState({
    operatorId: "-1",
    active: "-1",
    operatorAccountRoleId: "-1",
  });
  const [editModalObj, setEditModelObj] = React.useState({
    open: false,
  });
  const [addModalObj, setAddModelObj] = React.useState({
    open: false,
    role: "-1",
    active: "-1",
    status: "-1",
    operatorAccountRoleId: "-1",
    username: "",
    userEmail: "",
    password: "",
    userMobile: "",
  });
  const [deleteModalObj, setDeleteModelObj] = React.useState({
    open: false,
    role: "-1",
    active: "-1",
    status: "-1",
    operatorAccountRoleId: "-1",
    username: "",
    userEmail: "",
    password: "",
    userMobile: "",
  });
  console.log({ deleteModalObj });
  const [changesMade, setChangesMade] = useState(false);
  console.log({ addModalObj });
  const [loadingButton, setLoadingButton] = React.useState(false);
  const [operatorAccountRoles, setOperatorAccountRoles] = React.useState([]);
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });
  const [filterButtonClicked, setFilterButtonClicked] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [filterVariables, setFilterVariables] = useState([]);

  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions
  );

  const navigate = useNavigate();

  // gql
  const operators = useQuery(OPERATORS);
  const [operatorAccountsByFilter, { refetch, loading, data: operatorData }] =
    useLazyQuery(OPERATOR_ACCOUNTS_BY_FILTER);

  const [updateOperatorAccountsMutation] = useMutation(
    UPDATE_OPERATOR_ACCOUNTS_MUTATION
  );
  const [createOperatorAccountsMutation] = useMutation(
    CREATE_OPERATOR_ACCOUNT_MUTATION
  );
  const [deleteOperatorAccount] = useMutation(DELETE_OPERATOR_ACCOUNT);
  const getAllOperatorRoles = useQuery(GET_OPERATOR_ROLES, {
    variables: {
      operatorId: JSON.parse(localStorage.getItem("user")).operator_id,
    },
    fetchPolicy: "no-cache",
  });
  const allOperatorAccountRoles = useQuery(ALL_OPERATOR_ACCOUNT_ROLES, {
    variables: {
      operatorId: JSON.parse(localStorage.getItem("user")).operator_id,
    },
    fetchPolicy: "no-cache",
  });
  // Handle Changes and Functions

  const copyPasswordToClipboard = () => {
    if (addModalObj.password && addModalObj.password != "") {
      navigator.clipboard.writeText(addModalObj.password);
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
        title: "",
        message: "Password copied to clipboard",
        open: true,
        actions: (
          <Button
            onClick={() => {
              setValidation({ open: false });
            }}
            value={"OK"}
            className={"p-2 w-full"}
          />
        ),
      });
    }
  };

  console.log({ addModalObj });
  const handleOnChange = (event) => {
    const { name, value } = event.target;
    setChangesMade(true);
    console.log({ editing: name, value });

    const numRegex = /^\d+$/;
    if (name === "operatorAccountRoleId") {
      // console.log(
      // 	operatorAccountRoles.find((x) => x.value === value).accessPermissions
      // );
      // setEditModelObj((prev) => ({
      // 	...prev,
      // 	[name]: value,
      // 	accessPermissions: operatorAccountRoles.find((x) => x.value === value)
      // 		.accessPermissions,
      // }));
      if (value === "-1") {
        setEditModelObj((prev) => ({
          ...prev,
          [name]: value,
          operatorAccountRoleId: value,
        }));
        return;
      } else {
        setEditModelObj((prev) => ({
          ...prev,
          [name]: value,
          accessPermissions: operatorAccountRoles.find((x) => x.value === value)
            .accessPermissions,
        }));
      }
    }

    if (name === "active") {
      if (value === "-1") {
        setEditModelObj((prev) => ({
          ...prev,
          [name]: value,
          active: value,
        }));
        return;
      } else {
        setEditModelObj((prev) => ({ ...prev, [name]: value }));
      }
    }
    if (name === "userMobile") {
      if (!numRegex.test(value) && value !== "") {
        return;
      }
      setEditModelObj((prev) => ({ ...prev, [name]: value }));
    } else {
      setEditModelObj((prev) => ({ ...prev, [name]: value }));
    }

    setChangesMade(true);
  };
  const handleOnChangeAdd = (event) => {
    const { name, value } = event.target;
    const numRegex = /^\d+$/;

    console.log({ add: name, addval: value });
    if (name === "operatorAccountRoleId") {
      if (value === "-1") {
        setAddModelObj((prev) => ({
          ...prev,
          [name]: value,
          operatorAccountRoleId: value,
        }));
        return;
      } else {
        setAddModelObj((prev) => ({
          ...prev,
          [name]: value,
          accessPermissions: operatorAccountRoles.find((x) => x.value === value)
            .accessPermissions,
        }));
      }
    }

    if (name === "active") {
      if (value === "-1") {
        setAddModelObj((prev) => ({
          ...prev,
          [name]: value,
          active: value,
        }));
        return;
      } else {
        setAddModelObj((prev) => ({ ...prev, [name]: value }));
      }
    }

    if (name === "userMobile") {
      if (!numRegex.test(value) && value !== "") {
        return;
      }
      setAddModelObj((prev) => ({ ...prev, [name]: value }));
    } else {
      setAddModelObj((prev) => ({ ...prev, [name]: value }));
    }
  };

  const buildVariables = () => {
    const variables = {};

    if (filter.active !== "-1") {
      let status = filter.active === "1" || filter.active === 1 ? true : false;
      variables.active = status;
    }

    if (filter.operatorAccountRoleId !== "-1") {
      variables.operatorAccountRoleId = filter.operatorAccountRoleId;
    }

    if (filter.userEmail !== "") {
      variables.userEmail = filter.userEmail;
    }

    // console.log({ variables });
    variables.operatorId = operatorId;
    return variables;
  };

  const handleSearch = (operatorAccountRoles) => {
    const variables = buildVariables();
    setFilterVariables(variables);
    setIsClicked(true);
    setIsLoading(true);
    setFilterButtonClicked(true);

    let tempVar = { ...filter };
    removeEmptyFields(tempVar);
    // setOperatorAccountList([]);
    // operatorAccountsByFilter({
    // 	variables: {
    // 		operatorId: JSON.parse(localStorage.getItem("user")).operator_id,
    // 	},
    // 	fetchPolicy: "no-cache",
    // })
    // 	.then((data) => {
    // 		if (data.data) {
    // 			let tempVar = [];
    // 			data.data.operatorAccountsByFilter.forEach((element) => {
    // 				if (
    // 					localStorage.getItem("user") &&
    // 					JSON.parse(localStorage.getItem("user")).operatorAccountId !==
    // 						element.operatorAccountId
    // 				) {
    // 					const roleMap = new Map();
    // 					operatorAccountRoles?.forEach((role) => {
    // 						roleMap.set(parseInt(role.value), role.name);
    // 					});

    // 					console.log({ element, roleMap, operatorAccountRoles });

    // 					// If role is found, merge the role and permissions with the account data
    // 					const updatedElement = {
    // 						...element,
    // 						company: element.operator.company,
    // 						active: element.active ? "Active" : "Disabled",
    // 						userMobile: element.userMobile.replace("639", ""),
    // 						roleName:
    // 							element.operatorAccountRoleId !== 0 &&
    // 							roleMap.has(element.operatorAccountRoleId)
    // 								? roleMap.get(element.operatorAccountRoleId)
    // 								: "-",
    // 					};

    // 					tempVar.push(updatedElement);
    // 				}
    // 			});
    // 			setOperatorAccountList(tempVar);
    // 		}
    // 	})
    // 	.catch((e) => console.log(e));
  };
  console.log({ filterButtonClicked });
  useEffect(() => {
    if (filterButtonClicked) {
      operatorAccountsByFilter({ variables: filterVariables });

      setFilterButtonClicked(false);
    }
  }, [filterButtonClicked, filterVariables]);

  console.log({ filter });

  useEffect(() => {
    if (operatorData && operatorData.operatorAccountsByFilter.length > 0) {
      // const roleMap = new Map();
      // operatorAccountRoles.forEach((role) => {
      // 	roleMap.set(role.value, role.label);
      // });

      let accounts = operatorData.operatorAccountsByFilter.map((op) => ({
        userEmail: op.userEmail,
        userMobile: op.userMobile.replace("639", ""),
        username: op.username,
        active: op.active,
        operatorId: operatorId,
        operatorAccountId: op.operatorAccountId,
        operatorAccountRoleId: op.operatorAccountRoleId,
        // roleName:
        //   global.globalAccountRoleId !== null &&
        //   roleMap.has(global.globalAccountRoleId)
        //     ? roleMap.get(global.globalAccountRoleId.toString())
        //     : "-",
        company: operatorList.find(
          (operatorname) =>
            parseInt(operatorname.value) === parseInt(operatorId)
        )?.name,
        roleName:
          op.operatorAccountRoleId !== null
            ? operatorAccountRoles.find(
                (role) =>
                  parseInt(role.value) === parseInt(op.operatorAccountRoleId)
              )?.name
            : "-",
      }));
      console.log({ accounts });
      setIsLoading(false);
      setOperatorAccountList(accounts);
    } else {
      setOperatorAccountList([]);
      setIsLoading(false);
    }
  }, [operatorData]);

  // useEffect(() => {
  // 	if (operatorAcciuntList.length > 0 && operatorAccountRoles.length > 0) {
  // 		console.log({ operatorAcciuntList });

  // 		operatorAcciuntList.forEach((operatorAccount) => {
  // 			console.log({ operatorAccount });

  // 			// Find the role where the value matches the operatorAccountId
  // 			const roleName = operatorAccountRoles.find(
  // 				(role) =>
  // 					parseInt(role.value) === parseInt(operatorAccount.operatorAccountId)
  // 			);

  // 			console.log({ roleName });
  // 		});
  // 	}
  // }, [operatorAcciuntList, operatorAccountRoles]);

  console.log({ operatorAccountRoles });

  const handleUpdate = () => {
    console.log({ editModalObj });
    setLoadingButton(true);
    const tempObj = { ...editModalObj };
    const operatorAccountId = tempObj.operatorAccountId;
    tempObj.active = editModalObj.active === "1" ? true : false;
    // tempObj.adminAccess = editModalObj.operatorAccountRoleId;
    tempObj.roleName =
      editModalObj.operatorAccountRoleId !== null
        ? operatorAccountRoles.find(
            (role) =>
              parseInt(role.value) ===
              parseInt(editModalObj.operatorAccountRoleId)
          )?.name
        : "-";

    tempObj.adminAccess =
      tempObj.roleName === "Admin" || tempObj.roleName === "Super Admin"
        ? true
        : false;
    tempObj.userMobile = `639${editModalObj.userMobile}`;
    delete tempObj.open;
    delete tempObj.operatorAccountId;
    delete tempObj.roleName;
    delete tempObj.__typename;
    delete tempObj.operatorId;
    delete tempObj.username;
    delete tempObj.editablePartnerFees;
    delete tempObj.editableUserFees;
    delete tempObj.editableSellerFees;
    delete tempObj.company;
    delete tempObj.status;
    console.log(tempObj.accessPermissions);
    console.log(tempObj.operatorAccountRoleId);

    console.log({ tempObj });

    if (
      editModalObj.userEmail === "" ||
      editModalObj.status === "-1" ||
      editModalObj.active === "-1" ||
      editModalObj.username === "" ||
      editModalObj.userMobile === "" ||
      editModalObj.operatorAccountRoleId === "-1" ||
      editModalObj.operatorAccountRoleId === -1
    ) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Required field missing",
        message: "Please complete all the required fields",
        open: true,
        actions: (
          <Button
            onClick={() => {
              setValidation({ open: false });
            }}
            value={"Go back"}
            className={"p-2 w-full"}
          />
        ),
      });
      setLoadingButton(false);

      return;
    } else {
      updateOperatorAccountsMutation({
        variables: { operatorAccountId: operatorAccountId, inputData: tempObj },
      })
        .then((data) => {
          console.log(data);
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
            title: Strings.popup_success_title_default,
            message: Strings.popup_success_message_edit,
            open: true,
            actions: (
              <Button
                onClick={() => {
                  window.location.reload();
                  setAddModelObj({ open: false });
                }}
                value={"OK"}
                className={"p-2 w-full"}
              />
            ),
          });
        })
        .catch((e) => {
          if (
            e.message.includes(`duplicate key value violates unique constraint`)
          ) {
            setValidation({
              icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
              title: Strings.popup_error_title_duplicate,
              message: Strings.popup_duplicate_email_message,
              open: true,
              actions: (
                <Button
                  onClick={() => {
                    setValidation({ open: false });
                  }}
                  value={"Go back"}
                  className={"p-2 w-full"}
                />
              ),
            });
            setLoadingButton(false);
            return;
          }
        });

      // .finally(() => {
      // 	setEditModelObj({ open: false });
      // 	setLoadingButton(false);
      // });
    }
  };

  console.log({ editModalObj });
  const handleAdd = () => {
    //validate muna ng fields
    console.log({ addModalObj });
    // if empty
    if (
      addModalObj.userEmail === "" ||
      addModalObj.status === "-1" ||
      addModalObj.username === "" ||
      addModalObj.userMobile === "" ||
      addModalObj.operatorAccountRoleId === "-1"
    ) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Required field missing",
        message: "Please complete all the required fields",
        open: true,
        actions: (
          <Button
            onClick={() => {
              setValidation({ open: false });
            }}
            value={"Go back"}
            className={"p-2 w-full"}
          />
        ),
      });
      return;
    }

    if (addModalObj.username && addModalObj.username?.length < 6) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Usernae",
        message: "Username must have 6 or more characters",
        open: true,
        actions: (
          <Button
            onClick={() => {
              setValidation({ open: false });
            }}
            value={"Go back"}
            className={"p-2 w-full"}
          />
        ),
      });
      return;
    }

    if (addModalObj.userEmail && !emailRegex.test(addModalObj.userEmail)) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Email",
        message: "Please enter a valid email address",
        open: true,
        actions: (
          <Button
            onClick={() => {
              setValidation({ open: false });
            }}
            value={"Go back"}
            className={"p-2 w-full"}
          />
        ),
      });
      return;
    }

    if (addModalObj.userEmail && addModalObj.userEmail?.length < 6) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Email",
        message: "Please enter a valid email address",
        open: true,
        actions: (
          <Button
            onClick={() => {
              setValidation({ open: false });
            }}
            value={"Go back"}
            className={"p-2 w-full"}
          />
        ),
      });
      return;
    }

    if (addModalObj.password && addModalObj.password.length < 6) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Password",
        message: "Password must have 6 or more characters",
        open: true,
        actions: (
          <Button
            onClick={() => {
              setValidation({ open: false });
            }}
            value={"Go back"}
            className={"p-2 w-full"}
          />
        ),
      });
      return;
    }
    if (addModalObj.userMobile && addModalObj.userMobile.length != 9) {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Mobile Number",
        message: "Please enter the last 9 digits of you mobile number",
        open: true,
        actions: (
          <Button
            onClick={() => {
              setValidation({ open: false });
            }}
            value={"Go back"}
            className={"p-2 w-full"}
          />
        ),
      });
      return;
    }
    setLoadingButton(true);
    const tempObj = { ...addModalObj };
    tempObj.active = addModalObj.status === "1" ? true : false;
    tempObj.userMobile = `639${addModalObj.userMobile}`;
    tempObj.roleName =
      addModalObj.operatorAccountRoleId !== null
        ? operatorAccountRoles.find(
            (role) =>
              parseInt(role.value) ===
              parseInt(addModalObj.operatorAccountRoleId)
          )?.name
        : "-";

    tempObj.adminAccess =
      tempObj.roleName === "Admin" || tempObj.roleName === "Super Admin"
        ? true
        : false;
    delete tempObj.open;
    delete tempObj.role;
    console.log({ tempObj });

    tempObj.operatorId =
      JSON.parse(localStorage.getItem("user")) &&
      JSON.parse(localStorage.getItem("user")).operator_id;

    console.log({ tempObj });
    createOperatorAccountsMutation({
      variables: tempObj,
    })
      .then((data) => {
        // handleSearch();
        // refetch();
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
          title: Strings.popup_success_title_default,
          message: Strings.popup_success_message_add,
          open: true,
          actions: (
            <Button
              onClick={() => {
                window.location.reload();
                setAddModelObj({ open: false });
              }}
              value={"OK"}
              className={"p-2 w-full"}
            />
          ),
        });
      })
      .catch((e) => {
        if (
          e.message.includes(`duplicate key value violates unique constraint`)
        ) {
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
            title: Strings.popup_error_title_duplicate,
            message: Strings.popup_duplicate_email_message,
            open: true,
            actions: (
              <Button
                onClick={() => {
                  setValidation({ open: false });
                }}
                value={"Go back"}
                className={"p-2 w-full"}
              />
            ),
          });
          setLoadingButton(false);
          return;
        }
      });

    // .finally(() => {
    // 	setLoadingButton(false);
    // });
  };

  const deleteAccount = (rowData) => {
    console.log({ rowData });
    deleteOperatorAccount({
      variables: { operatorAccountId: rowData.operatorAccountId },
    })
      .then((response) => {
        setValidation({
          icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
          title: Strings.popup_success_title_default,
          message: "Account deleted successfully",
          open: true,
          actions: (
            <Button
              onClick={() => {
                setValidation({ open: false });
                window.location.reload();
              }}
              value={"OK"}
              className={"p-2 w-full"}
            />
          ),
        });
        setDeleteModelObj({ open: false });
      })
      .catch((e) => {
        console.error({ e });
        return;
      });
  };
  // use Effects
  React.useEffect(() => {
    if (operators.data) {
      let tempVar = [];
      operators.data.operators.forEach((element) => {
        tempVar.push({ name: element.company, value: element.operatorId });
      });
      setOperatorList(tempVar);
    }
  }, [operators.data]);
  // React.useEffect(() => {
  // 	handleSearch();
  // }, []);
  React.useEffect(() => {
    if (allOperatorAccountRoles.data) {
      console.log(allOperatorAccountRoles.data);

      let tempArr = allOperatorAccountRoles.data.allOperatorAccountRoles.map(
        (element) => ({
          value: element.operatorAccountRoleId,
          name: element.roleName,
          accessPermissions: element.accessPermissions,
        })
      );

      setOperatorAccountRoles(tempArr);
    }
  }, [allOperatorAccountRoles.data]);

  // React.useEffect(() => {
  // 	if (operatorAccountRoles.length > 0) {
  // 		handleSearch(operatorAccountRoles);
  // 	}
  // }, [operatorAccountRoles]);

  console.log({ operatorAcciuntList });
  console.log({ isClicked });
  return (
    <ContentContainer containerTitle={"Operator Accounts"}>
      <div className="gap-2 my-4">
        <div className="grid grid-cols-5 space-y-2">
          <div className="col-span-4">
            <div className="grid-cols-9 grid items-center">
              <div className="col-span-1">Status:</div>
              <Select
                className={"col-span-7"}
                defaultOption={{ name: "-- ALL --", value: "-1" }}
                items={[
                  { value: "1", name: "Active" },
                  { value: "0", name: "Inactive" },
                ]}
                value={filter.active}
                onChange={(e) =>
                  setFilter((prev) => ({ ...prev, active: e.target.value }))
                }
              />
            </div>
          </div>
          <div className="col-span-1"></div>

          <div className="col-span-4">
            <div className="grid-cols-9 grid items-center">
              <div className="col-span-1">Role:</div>
              <Select
                defaultOption={{ name: "-- ALL --", value: "-1" }}
                className={"col-span-7 "}
                items={operatorAccountRoles}
                maxLength={32}
                value={filter.operatorAccountRoleId}
                onChange={(e) =>
                  setFilter((prev) => ({
                    ...prev,
                    operatorAccountRoleId: e.target.value,
                  }))
                }
              />
            </div>
          </div>
          <div className="col-span-1"></div>

          <div className="col-span-4">
            <div className="grid-cols-9 grid items-center">
              <div className="col-span-1">Email:</div>
              <InputText
                className={"col-span-7 px-4"}
                maxLength={32}
                value={filter.userEmail}
                onChange={(e) =>
                  setFilter((prev) => ({ ...prev, userEmail: e.target.value }))
                }
                pt={{
                  root: {
                    className: "border border-gray-200 rounded-lg w-full h-10",
                  },
                }}
              />
            </div>
          </div>
          <div className="col-span-1"></div>

          <div className="col-span-3"></div>

          <div className="grid grid-cols-2 w-1/2 gap-y-2">
            {/* <div></div> */}
            <u
              className="flex hover:text-blue-500 cursor-pointer mt-4 ml-auto w-min"
              onClick={() => {
                setFilter({
                  active: "-1",
                  operatorAccountRoleId: "-1",
                  userEmail: "",
                });
              }}
            >
              <i className="fas fa-undo my-auto"></i>
              <p className="ml-1">Reset</p>
            </u>
          </div>
        </div>
        <Button
          className={"w-40 h-8 m-5"}
          value={"Search"}
          onClick={handleSearch}
        />

        <Button
          className={`p-2 mr-auto m-5 ${
            accessPermission.operatorAccounts === 1 ||
            accessPermission.operatorAccounts === "1"
              ? "hidden"
              : ""
          }`}
          value={"Add operator account"}
          onClick={() => setAddModelObj((prev) => ({ ...prev, open: true }))}
          disabled={
            isLoading ||
            accessPermission.operatorAccounts === 1 ||
            accessPermission.operatorAccounts === "1"
          }
        />
      </div>
      {/* {loading && data && <LinearProgressBar label="" open={loading} />} */}

      {isClicked &&
        (loading ? (
          <LoadingComponent />
        ) : (
          <>
            <Card>
              <TotalRecords count={operatorAcciuntList.length} />
              {/* <Table
							headers={[
								{ header_key: "active", header_name: "Status" },
								{ header_key: "username", header_name: "Username" },
								{ header_key: "userMobile", header_name: "Mobile number" },
								{ header_key: "userEmail", header_name: "Email" },
							]}
							items={operatorAcciuntList}
							fieldId="operatorAccountId"
							actionEdit={(data) => {
								let tempData = { ...data };
								delete tempData.operator;
								console.log(tempData.active);
								setEditModelObj({
									...tempData,
									open: true,
									active: tempData.active === "Active" ? "1" : "0",
								});
							}}
						/> */}

              <DataTable
                value={operatorAcciuntList}
                showGridlines
                stripedRows
                paginator
                multiple
                removableSort
                sortMode="multiple"
                rows={10}
                rowHover={true}
                emptyMessage="No accounts found"
                paginatorTemplate={paginatorTemplate}
              >
                <Column
                  headerClassName="bg-primary-primaryYellow text-center"
                  alignHeader={"center"}
                  header="Status"
                  sortable
                  field="active"
                  className="text-center w-[170px]"
                  body={(rowData) => {
                    return (
                      <>
                        <Badge
                          value={rowData.active ? "Active" : "Inactive"}
                          className={`flex justify-center  text-secondary-purpleGray items-center ${
                            rowData.active ? "bg-green-400" : "bg-gray-200"
                          } p-2 rounded`}
                        ></Badge>
                      </>
                    );
                  }}
                />
                <Column
                  headerClassName="bg-primary-primaryYellow text-center"
                  alignHeader={"center"}
                  header="Username"
                  sortable
                  field="username"
                  className="text-center"
                />
                <Column
                  headerClassName="bg-primary-primaryYellow text-center"
                  alignHeader={"center"}
                  header="Mobile Number"
                  sortable
                  field="userMobile"
                  className="text-center"
                  body={(rowData) => {
                    return (
                      <>
                        <div>{`639${rowData.userMobile}`}</div>
                      </>
                    );
                  }}
                />
                <Column
                  headerClassName="bg-primary-primaryYellow text-center"
                  alignHeader={"center"}
                  header="Email"
                  sortable
                  field="userEmail"
                  className="text-center"
                />
                <Column
                  headerClassName="bg-primary-primaryYellow text-center"
                  alignHeader={"center"}
                  header="Role"
                  sortable
                  field="roleName"
                  className="text-center"
                />
                <Column
                  headerClassName="bg-primary-primaryYellow text-center"
                  alignHeader={"center"}
                  header=""
                  className={`text-center`}
                  body={(rowData) => (
                    <div className="flex gap-3 items-center justify-center">
                      <PrimereactButton
                        // value={"Edit"}
                        // icon={`}`}

                        icon={` ${
                          accessPermission.operatorAccounts === 1 ||
                          accessPermission.operatorAccounts === "1"
                            ? "pi pi-eye"
                            : "pi pi-pencil"
                        }`}
                        className="bg-primary-primaryYellow text-black border-0 px-4 py-1 font-semibold"
                        onClick={() => {
                          let tempData = { ...rowData };
                          delete tempData.operator;
                          console.log(tempData.active);
                          setEditModelObj({
                            ...tempData,
                            open: true,
                            active: tempData.active ? "1" : "0",
                          });
                        }}
                      >
                        {/* Edit */}
                      </PrimereactButton>

                      <PrimereactButton
                        disabled={
                          rowData.operator === "19" ||
                          rowData.operatorAccountRoleId === 19 ||
                          rowData.roleName === "Super Admin"
                        }
                        icon="pi pi-trash"
                        className={`bg-red-400 text-black border-0 px-4 py-1  ${
                          accessPermission.operatorAccounts === 1 ||
                          accessPermission.operatorAccounts === "1"
                            ? "hidden"
                            : ""
                        }`}
                        onClick={() => {
                          let tempData = { ...rowData };
                          delete tempData.operator;
                          console.log(tempData.active);
                          setDeleteModelObj({
                            ...tempData,
                            open: true,
                            operatorAccountId: tempData.operatorAccountId,
                            // active: tempData.active === "Active" ? "1" : "0",
                          });
                        }}
                      >
                        {/* Delete */}
                      </PrimereactButton>
                    </div>
                  )}
                />
              </DataTable>
            </Card>
          </>
        ))}

      <Dialog
        visible={editModalObj.open}
        // onHide={() => setEditModelObj((prev) => ({ ...prev, open: false }))}
        onHide={() =>
          setEditModelObj({
            ...editModalObj,
            open: false,
            role: "-1",
            active: "-1",
            status: "-1",
            operatorAccountRoleId: "-1",
            username: "",
            userEmail: "",
            password: "",
            userMobile: "",
          })
        }
        headerClassName="uppercase"
        draggable={false}
        resizable={false}
        header={` ${
          accessPermission.operatorAccounts === 1 ||
          accessPermission.operatorAccounts === "1"
            ? "Operator Account Details"
            : "Edit Operator Account"
        }`}
        className="w-[650px]"
        footer={
          <>
            {/* <div className="flex flex-row gap-2">
              <Button
                className={`p-2 w-1/2  ${
                  accessPermission.operatorAccounts === 1 ||
                  accessPermission.operatorAccounts === "1"
                    ? "hidden"
                    : ""
                }`}
                value={"Email password recovery"}
                disabled={true}
              />
            </div> */}
            <div className="flex flex-row-reverse gap-2 pt-8">
              <Button
                className={`p-2 w-full ${
                  accessPermission.operatorAccounts === 1 ||
                  accessPermission.operatorAccounts === "1"
                    ? "hidden"
                    : ""
                }`}
                value={"Save"}
                disabled={!changesMade}
                onClick={handleUpdate}
                loading={loadingButton}
              />
            </div>
          </>
        }
        // style={{ overflowY: "auto" }}
      >
        <div className="grid grid-cols-6 items-center space-y-2">
          <div className="col-span-6 font-bold">Login Credentials</div>
          <div className="col-span-6 pb-3">
            <div className="grid grid-cols-7">
              {/* <div className="col-span-7"> */}
              <p className=" col-span-7">Email</p>
              <Textfield
                classNameParent="col-span-7"
                disabled
                value={editModalObj.userEmail}
                onChange={handleOnChange}
                name="userEmail"
              />
              {/* </div> */}
            </div>
          </div>

          <div className="col-span-6 font-bold">Others</div>
          {/* <div className="grid grid-cols-6 space-x-2 w-full"> */}
          <div className="col-span-6">
            <div className="grid grid-cols-6 space-x-2">
              <div className="col-span-3">
                <div className="grid grid-cols-4">
                  <p className="col-span-4">Username</p>
                  {/* <p>{editModalObj.username}</p> */}
                  <Textfield
                    classNameParent="col-span-4"
                    disabled
                    value={editModalObj.username}
                    onChange={handleOnChange}
                    name="username"
                  />
                </div>
              </div>
              <div className="col-span-3">
                <div className="grid grid-cols-4">
                  <p className="col-span-4">Operator</p>
                  {/* <p>{editModalObj.username}</p> */}
                  <Textfield
                    classNameParent="col-span-4"
                    disabled
                    value={editModalObj.company}
                    onChange={handleOnChange}
                    name="company"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* new row */}
          <div className="col-span-6">
            <div className="grid grid-cols-6 space-x-2">
              <div className="col-span-3">
                <div className="grid grid-cols-4">
                  <p className="col-span-4">
                    <span className="text-red-500">* </span>Mobile Number
                  </p>
                  {/* <p>{editModalObj.username}</p> */}
                  <div className="col-span-4 ">
                    <div className="grid grid-cols-12 items-center ">
                      <p className="col-span-2">+63 9</p>
                      <InputText
                        type="int"
                        onChange={handleOnChange}
                        name="userMobile"
                        value={editModalObj.userMobile}
                        // prefix="+639"
                        // onPaste={(e) => {
                        // 	e.preventDefault();
                        // }}
                        readOnly={
                          accessPermission.operatorAccounts === 1 ||
                          accessPermission.operatorAccounts === "1"
                        }
                        className="appearance-none col-span-10"
                        placeholder={"XXXXXXXXX"}
                        maxLength={9}
                        pt={{
                          root: {
                            className:
                              "border border-gray-200 p-1 h-10 rounded-md",
                          },
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-span-3">
                <div className="grid grid-cols-4">
                  {/* <div className=""> */}
                  <p className="col-span-4">
                    <span className="text-red-500">* </span>Status
                  </p>
                  <Select
                    value={editModalObj.active}
                    defaultOption={{ value: "-1", name: "-- Select Status --" }}
                    className={"col-span-4"}
                    items={[
                      { value: "1", name: "Active" },
                      { value: "0", name: "Inactive" },
                    ]}
                    disabled={
                      accessPermission.operatorAccounts === 1 ||
                      accessPermission.operatorAccounts === "1"
                    }
                    onChange={handleOnChange}
                    name="active"
                  />
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>

          {/* another row */}
          <div className="col-span-6">
            <div className="grid grid-cols-6 space-x-2 items-center">
              <div className="col-span-3">
                <div className="grid grid-cols-4">
                  <p className="col-span-4">
                    <span className="text-red-500">* </span>Roles/Template
                  </p>
                  <Select
                    value={editModalObj.operatorAccountRoleId}
                    defaultOption={{ value: "-1", name: "-- Select Role --" }}
                    className={"col-span-4"}
                    items={operatorAccountRoles}
                    onChange={handleOnChange}
                    name="operatorAccountRoleId"
                    disabled={
                      accessPermission.operatorAccounts === 1 ||
                      accessPermission.operatorAccounts === "1"
                    }
                  />
                </div>

                {/* <div className="grid grid-cols-2"> */}

                {/* </div> */}
              </div>
              <div className="col-span-3 items-center">
                {/* <div> */}
                {!editModalObj.roleName?.toLowerCase().includes("admin") && (
                  <Button
                    value="Override default permissions/settings"
                    className="p-1"
                    onClick={() => {
                      window.open(
                        `/operator/admin/operator-accounts/user-access-permission/${editModalObj.operatorAccountId}`,
                        "_blank"
                      );
                    }}
                  />
                )}

                {/* </div> */}
              </div>
            </div>
          </div>
          {/* </div> */}
        </div>
      </Dialog>

      <Dialog
        visible={addModalObj.open}
        // onHide={() => setAddModelObj((prev) => ({ ...prev, open: false }))}
        onHide={() =>
          setAddModelObj({
            ...addModalObj,
            open: false,
            role: "-1",
            active: "-1",
            status: "-1",
            operatorAccountRoleId: "-1",
            username: "",
            userEmail: "",
            password: "",
            userMobile: "",
          })
        }
        header="ADD OPERATOR ACCOUNT"
        style={{ overflowY: "auto" }}
      >
        <div>
          <div className="my-4 grid grid-cols-2 gap-4">
            {/* Create Select for this */}
            <div className="">
              <p className="font-bold">
                <span className="text-red-500">* </span>Username:
              </p>
              <Textfield
                value={addModalObj.username}
                onChange={handleOnChangeAdd}
                name="username"
              />
            </div>
            <div className="">
              <p className="font-bold">Operator:</p>
              <Textfield
                disabled={true}
                value={JSON.parse(localStorage.getItem("user")).company}
              />
            </div>
            <div className="">
              <p className="font-bold">
                <span className="text-red-500">* </span>Email
              </p>
              <Textfield
                value={addModalObj.userEmail}
                onChange={handleOnChangeAdd}
                name="userEmail"
              />
            </div>
            <div>
              <p className="font-bold">
                <span className="text-red-500">* </span>Password
              </p>
              <div className="flex flex-row items-center justify-center">
                <div className="flex gap-2">
                  <Textfield
                    value={addModalObj.password}
                    type={"password"}
                    onChange={handleOnChangeAdd}
                    name="password"
                    classNameParent={"text-indent-4"}
                  />
                  <div>
                    <button onClick={copyPasswordToClipboard}>
                      <i className={"fas fa-copy mt-4 rounded"}></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="">
              <p className="font-bold">
                <span className="text-red-500">* </span>Mobile Number
              </p>
              <div className="flex flex-row items-center gap-1">
                <p>+63 9</p>
                {/* <NumericFormat
									placeholder={"XXXXXXXXX"}
									className={"w-52"}
									maxLength={9}
									value={addModalObj.userMobile}
									onChange={handleOnChangeAdd}
									name="userMobile"
									customInput={Textfield}
								/> */}

                <InputText
                  type="int"
                  onChange={handleOnChangeAdd}
                  name="userMobile"
                  value={addModalObj.userMobile}
                  className="appearance-none col-span-4"
                  placeholder={"XXXXXXXXX"}
                  maxLength={9}
                  pt={{
                    root: {
                      className: "border border-gray-200 p-1 h-10 rounded-md",
                    },
                  }}
                />
              </div>
            </div>
            <div className="">
              <p className="font-bold">
                <span className="text-red-500">* </span>Active status
              </p>
              <Select
                value={addModalObj.status}
                className={"mb-2"}
                defaultOption={{ value: "-1", name: "-- Select Status --" }}
                items={[
                  { value: "1", name: "Active" },
                  { value: "0", name: "Inactive" },
                ]}
                onChange={handleOnChangeAdd}
                name="status"
              />
            </div>
            <div className="">
              <p className="font-bold">
                <span className="text-red-500">* </span>Roles/Template
              </p>
              <Select
                value={addModalObj.operatorAccountRoleId}
                // placeholder="-- Select Role\ --"
                defaultOption={{ value: "-1", name: "-- Select Role --" }}
                className={"mb-2"}
                items={operatorAccountRoles}
                onChange={handleOnChangeAdd}
                name="operatorAccountRoleId"
              />
            </div>
          </div>
          <div className="flex flex-row-reverse gap-2 pt-4">
            <Button
              className={"p-2 w-full"}
              value={"Save"}
              onClick={handleAdd}
              // loading={loadingButton}
            />
          </div>
        </div>
      </Dialog>

      <Dialog
        visible={deleteModalObj.open}
        // onHide={() => setAddModelObj((prev) => ({ ...prev, open: false }))}
        onHide={() =>
          setDeleteModelObj({
            ...deleteModalObj,
            open: false,
            role: "-1",
            active: "-1",
            status: "-1",
            operatorAccountRoleId: "-1",
            username: "",
            userEmail: "",
            password: "",
            userMobile: "",
          })
        }
        header={
          <div className="flex flex-col items-center justify-center">
            <img
              alt="cancel-icon"
              className="h-[90px] mr-2"
              src="https://files.axshare.com/gsc/WVWZ57/33/6d/24/336d246d351f4c1fa96b79e22e01b267/images/define_doors/u29.png?pageId=a40ab7eb-ce47-459a-9061-03fbe05c510f"
            />
            {/* <div className="font-bold">{`Delete Confirmation`}</div> */}
          </div>
        }
        style={{ overflowY: "auto" }}
        closable={false}
        draggable={false}
        className="w-[480px]"
      >
        <div>
          {/* <div className="my-4 grid grid-cols-2 gap-4"> */}
          <div className="text-lg text-center">
            Are you sure you want to delete this user with user email:{" "}
            <span className="font-semibold text-orange-400">
              {deleteModalObj.userEmail}
            </span>
            ?
          </div>

          <div className="pt-3 ">
            <div className="flex gap-2 w-full items-center justify-center">
              <PrimereactButton
                size="small"
                className="bg-white text-black  border border-primary-primaryYellow px-4 py-2 hover:bg-slate-100"
                onClick={() => {
                  setDeleteModelObj({ open: false });
                }}
              >
                Cancel
              </PrimereactButton>
              <PrimereactButton
                size="small"
                className="bg-primary-primaryYellow text-black border-0 hover:bg-primary-primaryYellowDark px-4 py-2"
                // disabled={isClicked}
                onClick={(e) => {
                  deleteAccount(deleteModalObj);
                }}
                label="Confirm"
              ></PrimereactButton>
            </div>
          </div>
        </div>
      </Dialog>
      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </ContentContainer>
  );
}
